<template>
    <div id="main-page">
        <div class="container">
          <app-bar
            title="Semua Event"
            previous-link="/" />
          <Loading v-if="loading.getEvent" />
          <div v-else-if="listEvent.length" class="row">
            <div v-for="event in listEvent" :key="event.id" class="col-12 col-md-4 pt-2 pb-2">
              <div class="card border-0 shadow" @click="handleOnClick(event)">
                <div class="card-body p-0">
                  <div class="d-flex flex-column">
                    <div class="img-wrapper">
                      <img class="icon-vouchers" :src="event.gambar_url">
                      <span class="badge-harga" :class="event.is_gratis === 't' ? 'badge-gratis' : 'badge-bayar'">
                        {{ event.label_harga }}
                      </span>
                      <span v-if="event.label_sisa_kuota" class="badge-kuota">
                        {{ event.label_sisa_kuota }}
                      </span>
                    </div>
                    <div class="pt-2 pb-3 px-3">
                      <h5 class="card-title fw-700">
                        {{ event.judul }}
                      </h5>
                      <div class="event-meta text-muted fs-13 mt-1" v-if="event.tgl_mulai">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                        {{ formatTanggal(event.tgl_mulai) }}
                      </div>
                      <div class="event-meta text-muted fs-13 mt-1" v-if="event.lokasi">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                        {{ event.lokasi }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="not-found d-flex flex-column text-center pb-5 pt-5">
            <div class="bd-highlight">
                <img src="@/assets/icon/not-found.png" alt="">
            </div>
            <div class="bd-highlight">
                <p class="text-title-active fm-poppins fst-normal fw-600 fs-24 lh-36">Tidak Ada Hasil</p>
            </div>
            <div class="bd-highlight">
                <p class="text-body-light fm-nunito fst-normal fw-400 fs-16 lh-21">Saat ini belum ada event yang tersedia.</p>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import AppBar from '@/components/AppBar'
import { nextTick, onMounted } from 'vue'
import { title } from '@/core/page'
import Loading from '@/components/utility/Loading'
import { useRouter } from 'vue-router'
import { getEvent, listEvent, loading } from '@/core/event'

export default {
  components: {
    AppBar, Loading
  },
  setup () {
    const router = useRouter()

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des']

    const formatTanggal = (tgl) => {
      if (!tgl) return ''
      const date = new Date(tgl.replace(' ', 'T'))
      const day = date.getDate()
      const month = months[date.getMonth()]
      const year = date.getFullYear()
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${day} ${month} ${year} · ${hours}:${minutes} WIB`
    }

    onMounted(async () => {
      await getEvent()

      nextTick(() => {
        title.value = 'Semua Event'
      })
    })

    const handleOnClick = (event) => {
      router.push({
        name: 'EventDetail',
        params: { id: event.id }
      })
    }

    return {
      loading,
      handleOnClick,
      listEvent,
      formatTanggal
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-vouchers {
  width: 100%;
  height: 210px;
  display: block;
  object-fit: contain;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.img-wrapper {
  position: relative;

  .badge-harga {
    position: absolute;
    top: 8px;
    left: 8px;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    line-height: 1.4;

    &.badge-gratis {
      background-color: #198754;
      color: #fff;
    }

    &.badge-bayar {
      background-color: #fff;
      color: var(--color-primary, #0d6efd);
      box-shadow: 0 1px 4px rgba(0,0,0,0.15);
    }
  }

  .badge-kuota {
    position: absolute;
    top: 8px;
    right: 8px;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    line-height: 1.4;
    background-color: #fff3cd;
    color: #856404;
    box-shadow: 0 1px 4px rgba(0,0,0,0.15);
  }
}

.card {
  border-radius: 10px;
  cursor: pointer;
  height: 100%;

  .card-title {
    font-size: 16px;
    line-height: 22px;

    @media (max-width: 580px) {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 2px;
    }
  }
}

.event-meta {
  display: flex;
  align-items: center;
  gap: 5px;

  svg {
    flex-shrink: 0;
  }
}
</style>
